document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.getElementById('dropdown-overlay');
  const header = document.querySelector('.header');
  const announcementBar = document.querySelector('.announcement-bar');

function closeAllDropdowns() {
  document.querySelectorAll('.dropdown--open').forEach((openDropdown) => {
    openDropdown.classList.remove('dropdown--open');
    const toggleLink = openDropdown.querySelector('.dropdown__toggle');
    if (toggleLink) {
      toggleLink.setAttribute('aria-expanded', 'false');
    }
    const dropdownMenu = openDropdown.querySelector('.dropdown__menu, .dbtfy-mega-menu__dropdown');
    if (dropdownMenu) {
      dropdownMenu.style.top = '';
      dropdownMenu.style.position = '';
      dropdownMenu.classList.remove('fixed-dropdown');
    }
  });
  if (overlay) {
    overlay.classList.remove('active');
    overlay.style.display = 'none';
  }
}


  // Click handler for menu items using event delegation
  document.body.addEventListener('click', function (event) {
    if (event.target.matches('.dropdown__toggle, .dropdown__toggle *')) {
      event.preventDefault();
      event.stopPropagation();

      // Find the closest .dropdown__toggle in case an inner element was clicked
      let toggleElement = event.target.closest('.dropdown__toggle');
      const dropdownContainer = toggleElement.closest('.dropdown, .dbtfy-mega-menu__item');
      const isOpen = dropdownContainer.classList.contains('dropdown--open');

      // Close all dropdowns
      closeAllDropdowns();

      // Toggle the clicked dropdown
      if (!isOpen) {
        dropdownContainer.classList.add('dropdown--open');
        toggleElement.setAttribute('aria-expanded', 'true');

        if (overlay) {
          overlay.classList.add('active');
          overlay.style.display = 'block';
        }
        // Adjust the dropdown position
        adjustDropdownPosition();
      } else {
        toggleElement.setAttribute('aria-expanded', 'false');
      }
    }
  });

  // Click handler for overlay
  if (overlay) {
    overlay.addEventListener('click', function () {
      closeAllDropdowns();
    });
  }

  // Close dropdowns when clicking outside
  document.addEventListener('click', function (event) {
    if (
      !event.target.closest('.dropdown') &&
      !event.target.closest('.dbtfy-mega-menu__item')
    ) {
      closeAllDropdowns();
    }
  });

  // Prevent clicks inside dropdown from closing it
  document.body.addEventListener('click', function (event) {
    if (event.target.closest('.dropdown__menu, .dbtfy-mega-menu__dropdown')) {
      event.stopPropagation();
    }
  });

  // Function to adjust dropdown position
  function adjustDropdownPosition() {
    const headerRect = header.getBoundingClientRect();
    let announcementBarHeight = 0;

    if (announcementBar) {
      const announcementBarRect = announcementBar.getBoundingClientRect();
      announcementBarHeight = announcementBarRect.height;
    }

    const isHeaderFullyOutOfView = headerRect.bottom <= announcementBarHeight;

    const openDropdowns = document.querySelectorAll(
      '.dropdown--open > .dropdown__menu, .dropdown--open > .dbtfy-mega-menu__dropdown'
    );

    openDropdowns.forEach((dropdownMenu) => {
      if (isHeaderFullyOutOfView) {
        // Header is fully scrolled out of view
        // Fix the dropdown to the top (under announcement bar)
        dropdownMenu.style.position = 'fixed';
        dropdownMenu.style.top = `${announcementBarHeight}px`;
        dropdownMenu.style.left = '0';
        dropdownMenu.style.width = '100%';
        dropdownMenu.style.zIndex = '999';
        dropdownMenu.classList.add('fixed-dropdown');
      } else {
        // Header is visible (even partially)
        // Position the dropdown directly under the header
        const headerBottom = headerRect.bottom;
        dropdownMenu.style.position = 'absolute';
        dropdownMenu.style.top = `${header.offsetHeight}px`;
        dropdownMenu.style.left = '0';
        dropdownMenu.style.width = '100%';
        dropdownMenu.style.zIndex = '999';
        dropdownMenu.classList.remove('fixed-dropdown');
      }
    });
  }

  window.addEventListener('scroll', adjustDropdownPosition);

  // Initial call to adjustDropdownPosition in case the page is already scrolled
  adjustDropdownPosition();
});
